/**
 * Navigation Module — dropdowns, mobile menu, sticky
 */

export const Navigation = {
	init() {
		this.toggle = document.querySelector( '.primary-nav__toggle' );
		this.mobileMenu = document.querySelector( '.mobile-menu' );
		this.dropdowns = document.querySelectorAll( '[data-dropdown]' );

		if ( this.toggle && this.mobileMenu ) {
			this.toggle.addEventListener( 'click', () => this.toggleMobile() );
			this.initResizeClose();
		}

		this.initDropdowns();
		this.initMobileAccordion();
	},

	toggleMobile() {
		const isOpen = this.mobileMenu.classList.contains( 'is-open' );
		this.mobileMenu.classList.toggle( 'is-open' );
		document.body.style.overflow = isOpen ? '' : 'hidden';
		document.body.classList.toggle( 'menu-open', ! isOpen );
		this.mobileMenu.setAttribute( 'aria-hidden', isOpen ? 'true' : 'false' );

		// Toggle burger icon ↔ X icon
		this.toggle.classList.toggle( 'is-active' );
	},

	initDropdowns() {
		this.dropdowns.forEach( ( trigger ) => {
			trigger.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				const target = document.getElementById( trigger.getAttribute( 'aria-controls' ) );
				const isOpen = trigger.getAttribute( 'aria-expanded' ) === 'true';

				// Close all others.
				this.dropdowns.forEach( ( d ) => {
					d.setAttribute( 'aria-expanded', 'false' );
					const t = document.getElementById( d.getAttribute( 'aria-controls' ) );
					if ( t ) t.hidden = true;
				} );

				if ( ! isOpen && target ) {
					trigger.setAttribute( 'aria-expanded', 'true' );
					target.hidden = false;
				}
			} );
		} );

		// Close on outside click.
		document.addEventListener( 'click', ( e ) => {
			if ( ! e.target.closest( '[data-dropdown], [data-dropdown-menu]' ) ) {
				this.dropdowns.forEach( ( d ) => {
					d.setAttribute( 'aria-expanded', 'false' );
					const t = document.getElementById( d.getAttribute( 'aria-controls' ) );
					if ( t ) t.hidden = true;
				} );
			}
		} );
	},

	initResizeClose() {
		let resizeTimer;
		window.addEventListener( 'resize', () => {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( () => {
				if ( this.mobileMenu.classList.contains( 'is-open' ) ) {
					this.mobileMenu.classList.remove( 'is-open' );
					this.toggle.classList.remove( 'is-active' );
					this.mobileMenu.setAttribute( 'aria-hidden', 'true' );
					document.body.style.overflow = '';
					document.body.classList.remove( 'menu-open' );
				}
			}, 150 );
		} );
	},

	initMobileAccordion() {
		const toggles = document.querySelectorAll( '[data-mobile-accordion]' );
		toggles.forEach( ( btn ) => {
			const panel = btn.nextElementSibling;
			if ( ! panel ) return;

			btn.setAttribute( 'aria-expanded', 'false' );

			btn.addEventListener( 'click', () => {
				const isOpen = btn.getAttribute( 'aria-expanded' ) === 'true';
				btn.setAttribute( 'aria-expanded', isOpen ? 'false' : 'true' );
				panel.hidden = isOpen;
			} );
		} );
	},
};
